<!--View Mode-->
@if (action == 'view') {
  <td class="tableColumn">{{client.id}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.name}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.apiKey}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.accessKey}}</td>
}
@if (action == 'view' && isAdminClient) {
  <td class="tableColumn">
    <div class="{{isActiveCssClass}}">
      @if (actionHappening != 'disable') {
        <input class="form-check-input" type="checkbox" id="cbIsActive" [disabled]="!isAdminClient || isLoading" [checked]="client.isActive" (change)="disableClient('view')" [(ngModel)]="client.isActive">
      }
    </div>
  </td>
}
@if (action == 'view' && !isAdminClient) {
  <td class="tableColumn">
    {{client.isActive}}
  </td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.clientType}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.accessAssociationIds}}</td>
}
@if (action == 'view') {
  <td class="tableColumn">{{client.updateDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
}
@if (action == 'view' && isAdminClient) {
  <td>
    <button type="button" class="m-1" (click)="updateAction('update')"><i class="bi bi-pencil-square" title="Update"></i></button>
  </td>
}
@if (action == 'view' && isAdminClient) {
  <td class="tableColumn">
    @if (isAdminClient) {
      <button type="button" class="m-1" (click)="openConfirmationDialog()" [disabled]="isLoading">@if (actionHappening != 'delete') {
        <i class="bi bi-archive-fill" title="Delete"></i>
        }@if (actionHappening == 'delete') {
        <i class="spinner-border spinner-border-sm"></i>
      }</button>
    }
  </td>
}



@if (action == 'create') {
  <div class="table-responsive-sm">
    <table>
      <tr class="row"><td>Client Details</td></tr>
      <tr class="row">
        <td class="col-5 gy-1">Client Id <span class="requiredField">*</span></td>
        <td class="col-5 gy-1">
          <input type="text" appTrim [(ngModel)]="client.id" name="txtClientId" id="txtClientId" placeholder="Client Id" required #txtClientId="ngModel" pattern="[a-zA-Z0-9]{1,20}" minlength="1" maxlength="20" />
        </td>
      </tr>
      @if (txtClientId.invalid && (txtClientId.dirty || txtClientId.touched)) {
        <tr>
          @if (txtClientId.errors?.['required']) {
            <td> Client Id is required </td>
          }
          @if (txtClientId.errors?.['pattern'] || txtClientId.errors?.['minlength'] || txtClientId.errors?.['maxlength']) {
            <td> Only Alphanumericals of max length 20 are allowed </td>
          }
        </tr>
      }
      <tr class="row">
        <td class="col-5 gy-1">Name <span class="requiredField">*</span></td>
        <td class="col-5 gy-1">
          <input type="text" appTrim [(ngModel)]="client.name" name="txtClientName" id="txtClientName" placeholder="Client Name" required #txtClientName="ngModel" pattern="[a-zA-Z0-9 ]{1,50}" minlength="1" maxlength="50" />
        </td>
      </tr>
      @if (txtClientName.invalid && (txtClientName.dirty || txtClientName.touched)) {
        <tr>
          @if (txtClientName.errors?.['required']) {
            <td> Name is required </td>
          }
          @if (txtClientName.errors?.['pattern'] || txtClientName.errors?.['minlength'] || txtClientName.errors?.['maxlength']) {
            <td> Only Alphanumericals of max length 50 are allowed </td>
          }
        </tr>
      }
      <tr class="row">
        <td class="col-5 gy-1 ">Client Type <span class="requiredField">*</span></td>
        <td class="col-5 gy-1 ">
          <select [(ngModel)]="client.clientType" id="clientType" (change)="loadAssociations('view')">
            <option value="tenant" selected>Tenant</option>
            <option value="terminal" selected>Terminal</option>
          </select>
        </td>
      </tr>
      @if (isLoading) {
        <tr class="d-flex justify-content-center m-3">
          <td class="spinner-border" role="status">
            <span class="sr-only"></span>
          </td>
        </tr>
      }
      @if (((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0)) {
        <tr class="row">
          <td>Associate Tenants</td>
        </tr>
      }
      @if (((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0)) {
        <tr>
          <td colspan="1" class="col-10 gy-1 ">
            <div class="accordion" id="filterAccordian">
              <div class="accordion-item">
                <h2 class="accordion-header" id="filterHeader">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilter" aria-expanded="true" aria-controls="collapseFilter">
                    Filters
                  </button>
                </h2>
                <div id="collapseFilter" class="accordion-collapse collapse" aria-labelledby="filterHeader" data-bs-parent="#filterAccordian">
                  <div class="accordion-body">
                    <div class="table-responsive-sm">
                      <table>
                        <tr class="row">
                          <td class="col-5">Tenant Id</td>
                          <td class="col-5"><input placeholder="Id" type="text" [(ngModel)]="searchTenantId" id="txtTenantId" (keyup.enter)="searchTenants()" /></td>
                        </tr>
                        <tr class="row">
                          <td class="col-10 ">
                            <button type="button" class="m-1" (click)="searchTenants()"><i class="bi bi-search" title="Search"></i></button>
                            <button type="button" class="m-1" (click)="reloadTenants()"><i class="bi-x-square-fill" title="Reset"></i></button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      }
      @if (((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0)) {
        <tr class="row">
          <td class="col-5 gy-1">Select</td>
          <td class="col-5 gy-1">Tenant ID</td>
        </tr>
      }
      @for (accessAssociation of (filteredApiTenants | paginate: {id: 'apiTenantsPagination', itemsPerPage:10, currentPage: apiTenantPage} ); track accessAssociation) {
        <tr class="row">
          @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
            <td class="col-5 gy-1">
              <input class="form-check-input" type="checkbox" id="cb{{accessAssociation.name}}" [disabled]="(isLoading || tenantsSelected  > 0) && !accessAssociation.isAssociated" (change)="apiTenantSelected(accessAssociation.isAssociated)" [(ngModel)]="accessAssociation.isAssociated">
            </td>
          }
          @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
            <td class="col-5 gy-1">
              {{accessAssociation.name}}
            </td>
          }
        </tr>
      }
      @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
        <tr>
          <td>
            <pagination-controls id="apiTenantsPagination" (pageChange)="apiTenantPage = $event" [directionLinks]="true"
              [autoHide]="true"
              [responsive]="true"
              previousLabel="Previous"
              nextLabel="Next"
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            screenReaderCurrentLabel="You're on page"></pagination-controls>
          </td>
        </tr>
      }
      <tr class="row">
        <td class="col-10 gy-1 ">
          <button type="button" class="m-1" (click)="createClient('view')" [disabled]="(txtClientId.invalid || txtClientName.invalid) || isLoading"> @if (actionHappening != 'create') {
            <i class="bi bi-check" title="Create"></i>
            } @if (actionHappening == 'create') {
            <i class="spinner-border spinner-border-sm"></i>
          }  </button>
          <button type="button" class="m-1" (click)="cancelCreate('view')" [disabled]="isLoading"><i class="bi bi-x-square" title="Cancel"></i></button>
        </td>
      </tr>
    </table>
  </div>
}

<!--Confirmation pop up-->
@if (actionHappening == 'delete') {
  <appPopup [displayStyle]="displayStyle" [entityName]="entityName" (popupOutputEvent)="confirmDelete($event)"></appPopup>
}


@if (action == 'update') {
  <div class="table-responsive-sm">
    <table>
      <tr class="row"><td>Client Details</td></tr>
      <tr class="row">
        <td class="col-5 gy-1">Client Id</td>
        <td class="col-5 gy-1">{{client.id}}</td>
      </tr>
      <tr class="row">
        <td class="col-5 gy-1">Name <span class="requiredField">*</span></td>
        @if (action == 'update') {
          <td class="col-5 gy-1">
            <input type="text" appTrim [(ngModel)]="client.name" name="txtClientName" id="txtClientName" required #txtClientName="ngModel" pattern="[a-zA-Z0-9 ]{1,50}" minlength="1" maxlength="50" />
            @if (txtClientName.invalid && (txtClientName.dirty || txtClientName.touched)) {
              <div class="tableColumn">
                @if (txtClientName.errors?.['required']) {
                  <span> Name is required </span>
                }
                @if (txtClientName.errors?.['pattern'] || txtClientName.errors?.['minlength'] || txtClientName.errors?.['maxlength']) {
                  <span> Only Alphanumericals of max length 50 are allowed </span>
                }
              </div>
            }
          </td>
        }
      </tr>
      <tr class="row">
        <td class="col-5 gy-1 ">Client Type <span class="requiredField">*</span></td>
        <td class="col-5 gy-1 ">
          <select [(ngModel)]="client.clientType" id="clientType" (change)="loadAssociations('view')">
            <option value="tenant">Tenant</option>
            <option value="terminal">Terminal</option>
          </select>
        </td>
      </tr>
      @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
        <tr class="row">
          <td>Associate Tenants</td>
        </tr>
      }
      @if (isLoading) {
        <tr class="d-flex justify-content-center m-3">
          <td class="spinner-border" role="status">
            <span class="sr-only"></span>
          </td>
        </tr>
      }
      @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
        <tr>
          <td colspan="1" class="col-10 gy-1 ">
            <div class="accordion" id="filterAccordian">
              <div class="accordion-item">
                <h2 class="accordion-header" id="filterHeader">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilter" aria-expanded="true" aria-controls="collapseFilter">
                    Filters
                  </button>
                </h2>
                <div id="collapseFilter" class="accordion-collapse collapse" aria-labelledby="filterHeader" data-bs-parent="#filterAccordian">
                  <div class="accordion-body">
                    <div class="table-responsive-sm">
                      <table>
                        <tr class="row">
                          <td class="col-5">Tenant Id</td>
                          <td class="col-5"><input placeholder="Id" type="text" [(ngModel)]="searchTenantId" id="txtTenantId" (keyup.enter)="searchTenants()" /></td>
                        </tr>
                        <tr class="row">
                          <td class="col-10 ">
                            <button type="button" class="m-1" (click)="searchTenants()"><i class="bi bi-search" title="Search"></i></button>
                            <button type="button" class="m-1" (click)="reloadTenants()"><i class="bi-x-square-fill" title="Reset"></i></button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      }
      @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
        <tr class="row">
          <td class="col-5 gy-1">Select</td>
          <td class="col-5 gy-1">Tenant ID</td>
        </tr>
      }
      @for (accessAssociation of (filteredApiTenants | paginate: {id: 'apiTenantsPagination', itemsPerPage:10, currentPage: apiTenantPage} ); track accessAssociation) {
        <tr class="row">
          @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
            <td class="col-5 gy-1">
              <input class="form-check-input" type="checkbox" id="cb{{accessAssociation.name}}" [disabled]="(!isAdminClient || isLoading || tenantsSelected  > 0 ) && !accessAssociation.isAssociated" [(ngModel)]="accessAssociation.isAssociated" (change)="apiTenantSelected(accessAssociation.isAssociated)">
            </td>
          }
          @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
            <td class="col-5 gy-1">
              {{accessAssociation.name}}
            </td>
          }
        </tr>
      }
      @if ((client.clientType == 'tenant' || client.clientType == 'terminal') && filteredApiTenants.length > 0) {
        <tr>
          <td>
            <pagination-controls id="apiTenantsPagination" (pageChange)="apiTenantPage = $event" [directionLinks]="true"
              [autoHide]="true"
              [responsive]="true"
              previousLabel="Previous"
              nextLabel="Next"
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            screenReaderCurrentLabel="You're on page"></pagination-controls>
          </td>
        </tr>
      }
      <tr class="row">
        <td class="col-10 gy-1 ">
          <button type="button" class="m-1" (click)="updateClient('view')" [disabled]="isLoading"> @if (actionHappening != 'update') {
            <i class="bi bi-check" title="Update"></i>
            } @if (actionHappening == 'update') {
            <i class="spinner-border spinner-border-sm"></i>
          }  </button>
          <button type="button" class="m-1" (click)="cancelEdit('view')" [disabled]="isLoading"><i class="bi bi-x-square" title="Cancel"></i></button>
        </td>
      </tr>
    </table>
  </div>
}
